<template lang="pug">
  .optional
    .export
      .label
        font-awesome-icon.download-icon(icon="download" size="lg")
        label.default-bold Export results as:
      .formats
        a.format(
          v-for="(format, i) in formats",
          :key="i"
          @click="selectFormat(format)"
          ) {{format | UpperCase}}
    //.views
      a(v-for="(v, i) in views", :key="i", :class="[view === v ? 'active' : '', 'view']", @click="changeView(v)") {{v}}
</template>

<script>

import { mapState, mapMutations, mapActions, } from 'vuex'
import ExportModal from '@/components/modals/ExportModal'
import { TOGGLE_EXPORT_MODAL, SET_EXPORT_FORMAT, } from '@/store/modules/search/mutations-types'

export default {
  name: 'SearchExport',
  components: {
    ExportModal,
  },
  data () {
    return {
      views: [ 'list', 'map', ],
      formats: [
        'csv',
        'json',
        'xml',
        'xlsx',
      ],
      view: 'list',
    }
  },
  computed: {
    isMaxExportResults () {
      return this.total <= 5000
    },

    ...mapState('search', [ 'total', ]),
  },
  methods: {
    changeView (v) {
      this.view = v
    },
    selectFormat (format) {
      this.setExportFormat(format)

      if (this.isMaxExportResults) {
        this.exportSearchResults(format)
      } else {
        this.showModal(true)
      }
    },

    ...mapActions('search', [ 'exportSearchResults', ]),
    ...mapMutations('search', {
      showModal: TOGGLE_EXPORT_MODAL,
      setExportFormat: SET_EXPORT_FORMAT,
    }),
  },
}
</script>

<style scoped lang="stylus">
  @import "../../assets/styles/variables.styl"

  .optional
    display flex
    align-items center
    .export
      display flex
      align-items center
      font-size 0.8rem
      .label
        display flex
        align-items center
        label
          margin 0 20px 0 10px
        .download-icon
          font-size 1.2rem
          color  $turquoise-color
      .formats
        display flex
        align-items center
        .format
          cursor pointer
          margin 0 3px
          color $cyprus-color
          font-weight 600
    .views
      margin-left 20px
      display flex
      .view
        background-color $white-color
        color $default-color-bold
        text-transform uppercase
        font-weight 600
        font-size 1rem
        border 2px solid $default-color
        width 80px
        height 35px
        display flex
        align-items center
        justify-content center
        &.active
          background-color $default-color
          color $white-color

</style>



// WEBPACK FOOTER //
// src/components/search-components/SearchExport.vue